import { render } from "./HomeSpellingRuleCategory.vue?vue&type=template&id=7b8a1f17&scoped=true&ts=true"
import script from "./HomeSpellingRuleCategory.vue?vue&type=script&lang=ts"
export * from "./HomeSpellingRuleCategory.vue?vue&type=script&lang=ts"

import "./HomeSpellingRuleCategory.vue?vue&type=style&index=0&id=7b8a1f17&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8a1f17"]])

export default __exports__